import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: none;
  padding-left: 15px;
  padding-right: 15px;
`;
